import script from "./SalesOffer.vue?vue&type=script&setup=true&lang=js"
export * from "./SalesOffer.vue?vue&type=script&setup=true&lang=js"

import "./SalesOffer.vue?vue&type=style&index=0&id=e6445c32&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e6445c32"]])

export default __exports__